const inboundRoutes = [
    {
        path: '/pickupAddressManagement',
        name: 'pickupAddressManagement',
        component: () => import('../../views/inbound/PickupAddressManagement.vue'),
        meta: { title: '送货地址' }
    },
    {
        path: '/inboundForecast',
        name: 'inboundForecast',
        component: () => import('../../views/inbound/InboundForecast.vue'),
        meta: { title: '入库预报' }
    },
    {
        path: '/claimPool',
        name: 'claimPool',
        component: () => import('../../views/inbound/ClaimPool.vue'),
        meta: { title: '认领池' }
    },
    {
        path: '/inboundForecastList',
        name: 'inboundForecastList',
        component: () => import('../../views/inbound/InboundForecastList.vue'),
        meta: { title: '预报列表', hidden: true }
    },
    {
        path: '/abnormalInboundOrder',
        name: 'abnormalInboundOrder',
        component: () => import('../../views/inbound/AbnormalInboundOrder.vue'),
        meta: { title: '异常入库单', hidden: true }
    }
]

export default inboundRoutes

